import { render, staticRenderFns } from "./IconReportFlag.vue?vue&type=template&id=6cbf6679&scoped=true&"
import script from "./IconReportFlag.vue?vue&type=script&lang=js&"
export * from "./IconReportFlag.vue?vue&type=script&lang=js&"
import style0 from "./IconReportFlag.vue?vue&type=style&index=0&id=6cbf6679&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf6679",
  null
  
)

export default component.exports